
import { useState } from 'react';

export default function AwardsTimelineSection() {
  const [selectedYear, setSelectedYear] = useState('2024');

  const timelineData = {
    '2024': [
      {
        title: '普洱茶年份茶全国销量第一品牌',
        issuer: '尚普咨询',
        month: '12月',
        description: '连续第五年获得全国销量第一认证',
        icon: 'ri-trophy-fill',
        image: 'https://public.readdy.ai/ai/img_res/fb55fbf39ac534b2d1ea361d5fd77502.jpg'
      },
      {
        title: '茶叶出口质量金奖',
        issuer: '中国茶叶进出口商会',
        month: '8月',
        description: '产品质量达到国际出口标准最高级别',
        icon: 'ri-medal-fill',
        image: 'https://readdy.ai/api/search-image?query=Chinese%20tea%20export%20quality%20gold%20medal%20award%2C%20international%20trade%20excellence%20recognition%20with%20golden%20medal%20and%20red%20ribbon%2C%20professional%20ceremony%20photography&width=300&height=200&seq=award-2024-2&orientation=landscape'
      },
      {
        title: '绿色食品认证续期',
        issuer: '中国绿色食品发展中心',
        month: '5月',
        description: '绿色食品认证成功续期，持续三年',
        icon: 'ri-leaf-fill',
        image: 'https://readdy.ai/api/search-image?query=Green%20food%20certification%20renewal%20document%20for%20tea%20products%2C%20official%20environmental%20quality%20certificate%20with%20green%20accents%20and%20nature%20elements%2C%20professional%20documentation%20photography&width=300&height=200&seq=award-2024-3&orientation=landscape'
      }
    ],
    '2023': [
      {
        title: '国宾伴手礼认证',
        issuer: '丝路沿线国家',
        month: '11月',
        description: '被多个丝路沿线国家指定为国宾级伴手礼',
        icon: 'ri-gift-fill',
        image: 'https://readdy.ai/api/search-image?query=Diplomatic%20gift%20certification%20ceremony%20for%20Chinese%20tea%20products%2C%20official%20government%20recognition%20with%20national%20flags%20and%20formal%20presentation%2C%20prestigious%20international%20award%20photography&width=300&height=200&seq=award-2023-1&orientation=landscape'
      },
      {
        title: '七星茶王奖',
        issuer: '中国茶叶协会',
        month: '9月',
        description: '获得茶叶行业最高荣誉七星茶王奖',
        icon: 'ri-star-fill',
        image: 'https://readdy.ai/api/search-image?query=Seven-star%20tea%20king%20award%20trophy%20ceremony%2C%20prestigious%20golden%20trophy%20with%20star%20design%20and%20purple%20ribbon%2C%20traditional%20Chinese%20tea%20ceremony%20background%20with%20modern%20luxury%20presentation&width=300&height=200&seq=award-2023-2&orientation=landscape'
      },
      {
        title: '有机茶认证',
        issuer: '中国有机产品认证中心',
        month: '6月',
        description: '通过有机茶产品认证，品质再次提升',
        icon: 'ri-seedling-fill',
        image: 'https://readdy.ai/api/search-image?query=Organic%20tea%20certification%20document%20with%20green%20natural%20elements%2C%20official%20environmental%20quality%20recognition%20certificate%2C%20professional%20organic%20farming%20award%20photography&width=300&height=200&seq=award-2023-3&orientation=landscape'
      }
    ],
    '2022': [
      {
        title: '茶叶质量安全示范企业',
        issuer: '国家质检总局',
        month: '10月',
        description: '被认定为茶叶质量安全示范企业',
        icon: 'ri-shield-check-fill',
        image: 'https://readdy.ai/api/search-image?query=National%20quality%20inspection%20bureau%20tea%20safety%20demonstration%20enterprise%20award%2C%20official%20government%20quality%20recognition%20certificate%20with%20blue%20accents%20and%20formal%20presentation&width=300&height=200&seq=award-2022-1&orientation=landscape'
      },
      {
        title: '中华老字号认证',
        issuer: '中华老字号认定委员会',
        month: '7月',
        description: '获得中华老字号品牌认证',
        icon: 'ri-ancient-gate-fill',
        image: 'https://readdy.ai/api/search-image?query=Chinese%20time-honored%20brand%20certification%20plaque%20with%20traditional%20Chinese%20calligraphy%20and%20red%20seals%2C%20prestigious%20heritage%20brand%20recognition%20with%20classical%20design%20elements&width=300&height=200&seq=award-2022-2&orientation=landscape'
      },
      {
        title: 'ISO22000食品安全认证',
        issuer: '国际标准化组织',
        month: '4月',
        description: '通过ISO22000食品安全管理体系认证',
        icon: 'ri-file-shield-fill',
        image: 'https://readdy.ai/api/search-image?query=ISO22000%20food%20safety%20certification%20document%20for%20tea%20manufacturing%2C%20international%20quality%20standard%20certificate%20with%20professional%20blue%20and%20white%20design%2C%20formal%20certification%20photography&width=300&height=200&seq=award-2022-3&orientation=landscape'
      }
    ],
    '2021': [
      {
        title: 'PICC产品责任险承保',
        issuer: '中国人民保险',
        month: '12月',
        description: '获得中国人民保险产品责任险承保',
        icon: 'ri-shield-fill',
        image: 'https://readdy.ai/api/search-image?query=PICC%20insurance%20coverage%20certificate%20for%20tea%20products%2C%20professional%20corporate%20insurance%20document%20with%20blue%20company%20colors%20and%20official%20seals%2C%20formal%20business%20documentation%20photography&width=300&height=200&seq=award-2021-1&orientation=landscape'
      },
      {
        title: '云南省茶叶龙头企业',
        issuer: '云南省农业厅',
        month: '8月',
        description: '被认定为云南省茶叶行业龙头企业',
        icon: 'ri-building-fill',
        image: 'https://readdy.ai/api/search-image?query=Yunnan%20provincial%20leading%20tea%20enterprise%20certificate%20with%20orange%20ribbon%20and%20regional%20authority%20seals%2C%20official%20provincial%20recognition%20document%20with%20formal%20presentation&width=300&height=200&seq=award-2021-2&orientation=landscape'
      },
      {
        title: '品牌价值评估证书',
        issuer: '中国品牌建设促进会',
        month: '5月',
        description: '品牌价值评估达到行业领先水平',
        icon: 'ri-bar-chart-fill',
        image: 'https://readdy.ai/api/search-image?query=Brand%20value%20assessment%20certificate%20for%20Chinese%20tea%20company%2C%20professional%20corporate%20valuation%20document%20with%20financial%20charts%20and%20gold%20accents%2C%20business%20excellence%20recognition%20photography&width=300&height=200&seq=award-2021-3&orientation=landscape'
      }
    ]
  };

  const years = Object.keys(timelineData).sort((a, b) => parseInt(b) - parseInt(a));

  return (
    <section className="py-16 lg:py-24 bg-[#f8f8f8]">
      <div className="mx-auto px-6 lg:px-[15%]">
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-2xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-[#663333] mb-4">
            荣誉时光轴
          </h2>
          <p className="text-sm sm:text-lg lg:text-xl text-gray-600 max-w-2xl mx-auto">
            见证我们一路走来的每一个重要时刻，每一份荣誉都是品质与实力的体现
          </p>
          <div className="w-24 h-1 bg-[#cc9966] mx-auto mt-6"></div>
        </div>

        {/* 年份选择器 */}
        <div className="flex justify-center mb-12">
          <div className="inline-flex bg-white rounded-full p-1 shadow-lg border border-gray-200">
            {years.map((year) => (
              <button
                key={year}
                onClick={() => setSelectedYear(year)}
                className={`px-6 py-3 rounded-full text-xs sm:text-sm font-semibold transition-all duration-300 cursor-pointer whitespace-nowrap ${
                  selectedYear === year
                    ? 'bg-[#cc9966] text-white shadow-md'
                    : 'text-[#663333] hover:text-[#cc9966] hover:bg-gray-50'
                }`}
              >
                {year}年
              </button>
            ))}
          </div>
        </div>

        {/* 时间轴内容 */}
        <div className="relative">
          {/* 时间轴线 */}
          <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-[#cc9966] hidden md:block"></div>

          <div className="space-y-8">
            {timelineData[selectedYear].map((award, index) => (
              <div key={index} className="relative flex flex-col md:flex-row items-start md:items-center group">
                {/* 时间轴节点 */}
                <div className="hidden md:flex absolute left-6 w-4 h-4 bg-[#cc9966] rounded-full border-4 border-white shadow-lg z-10"></div>
                
                {/* 月份标签 */}
                <div className="md:ml-20 mb-4 md:mb-0 md:mr-8 md:w-20 flex-shrink-0">
                  <div className="inline-block bg-[#cc9966] text-white px-3 py-1 rounded-full text-xs sm:text-sm font-semibold">
                    {award.month}
                  </div>
                </div>

                {/* 奖项卡片 */}
                <div className="flex-1 bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 transform group-hover:-translate-y-1 border border-gray-100">
                  <div className="flex flex-col lg:flex-row gap-6">
                    {/* 奖项图片 */}
                    <div className="lg:w-80 flex-shrink-0">
                      <div className="relative h-48 lg:h-40 rounded-xl overflow-hidden">
                        <img
                          src={award.image}
                          alt={award.title}
                          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                        />
                        <div className="absolute top-3 right-3 w-10 h-10 flex items-center justify-center bg-[#cc9966] rounded-full shadow-lg">
                          <i className={`${award.icon} text-sm text-white`}></i>
                        </div>
                      </div>
                    </div>

                    {/* 奖项信息 */}
                    <div className="flex-1 space-y-3">
                      <h3 className="text-sm sm:text-lg lg:text-xl font-bold text-[#663333] group-hover:text-[#cc9966] transition-colors">
                        {award.title}
                      </h3>
                      
                      <p className="text-xs sm:text-sm text-[#cc9966] font-semibold">
                        颁发机构：{award.issuer}
                      </p>
                      
                      <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                        {award.description}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 总结统计 */}
        <div className="mt-16 lg:mt-20 text-center">
          <div className="bg-white rounded-2xl p-8 lg:p-12 shadow-lg border border-gray-100">
            <h3 className="text-lg sm:text-xl lg:text-2xl xl:text-3xl font-bold text-[#663333] mb-8">
              近年来荣誉统计
            </h3>
            
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
              <div className="space-y-2">
                <div className="text-xl sm:text-3xl lg:text-4xl font-bold text-[#cc9966]">12</div>
                <div className="text-xs sm:text-base lg:text-lg text-gray-600">2021-2024年获奖</div>
              </div>
              
              <div className="space-y-2">
                <div className="text-xl sm:text-3xl lg:text-4xl font-bold text-[#cc9966]">8</div>
                <div className="text-xs sm:text-base lg:text-lg text-gray-600">国家级认证</div>
              </div>
              
              <div className="space-y-2">
                <div className="text-xl sm:text-3xl lg:text-4xl font-bold text-[#cc9966]">4</div>
                <div className="text-xs sm:text-base lg:text-lg text-gray-600">国际认证</div>
              </div>
              
              <div className="space-y-2">
                <div className="text-xl sm:text-3xl lg:text-4xl font-bold text-[#cc9966]">5</div>
                <div className="text-xs sm:text-base lg:text-lg text-gray-600">年度最高奖</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
